import React, { ReactNode } from 'react';

import { Paragraph } from 'common/components';

export const ModalInfoCardItem = ({
  children,
  fontFamily,
  fontSize,
  fontWeight,
  color,
  margin,
}: {
  children: ReactNode;
  fontFamily?: string;
  fontSize?: string;
  fontWeight?: string;
  color?: string;
  margin?: string;
}) => {
  return (
    <Paragraph
      fontFamily={fontFamily}
      fontSize={fontSize}
      fontWeight={fontWeight}
      color={color}
      margin={margin}
    >
      {children}
    </Paragraph>
  );
};
